module.exports = __webpack_public_path__ + "static/bobby-video-compressed-252781c0e9b593d62eaef060eca80d60.mp4";